import { useMutation } from '@tanstack/react-query'
import { axiosFilePost, FileEntry } from 'Redux/axiosHelper'

const requestFileUpload = async (newFile: any) => {
  const response = await FileEntry(newFile, `v1/files/request-upload`)
  return response.data
}
const uploadFile = async ({ payload, id }: { payload: any; id: string }) => {
  const res = await axiosFilePost(payload, `v1/files/upload/${id}`)
  return res.data
}

export const useFileUploadMutation = () => {
  return useMutation({
    // mutationFn: completeFileUpload,
    mutationFn: async ({
      payload,
      newFile,
    }: {
      payload: any
      newFile: any
    }) => {
      const uploadRequest = await requestFileUpload(newFile)
      const id = uploadRequest._id
      const uploadResult = await uploadFile({ payload, id })

      return {
        uploadRequest,
        uploadResult,
        id,
      }
    },
  })
}
